import { useAsyncFn } from 'react-use';

import { useCreatePatient, useUpdateCaregiver } from '@helpful/network';
import { useUser } from '@core/user';

import { PlanForm } from '../SignUp.types';

import { DetailsForm } from './Details.types';

type UseDetailsReturnType = [
  {
    value: string;
    loading: boolean;
    defaultValues: DetailsForm;
  },
  ({ patient }: DetailsForm) => Promise<string>
];

export const useDetails = ({
  zip,
  fips,
  plans = [],
  plan = null,
  supplemental = null,
  supplementals = [],
}: PlanForm): UseDetailsReturnType => {
  const [{ user }, refetch] = useUser();

  const { mutateAsync: createPatient } = useCreatePatient();
  const { mutateAsync: updateCaregiver } = useUpdateCaregiver();

  const defaultValues: DetailsForm = {
    caringForMyself: false,
    caregiver: {
      firstName: user?.firstName,
      lastName: user?.lastName,
    },
    patient: {
      zip: `${zip}`,
      fips: `${fips}`,
      firstName: '',
      lastName: '',
    },
  };

  const [{ loading, value }, dispatch] = useAsyncFn(
    async ({ patient, caregiver }: DetailsForm) => {
      const {
        data: { id: caregiverId },
      } = await updateCaregiver({ id: user.id, data: caregiver });
      const {
        data: { id: parientId },
      } = await createPatient({
        data: {
          caregivers: [
            {
              caregiver: {
                id: caregiverId,
              },
            },
          ],
          plans: [plan, supplemental, ...plans, ...supplementals]
            .filter((id) => !!id)
            .map((id) => ({ id })),
          ...patient,
        },
      });
      refetch();
      return parientId;
    },
    []
  );

  return [{ loading, value, defaultValues }, dispatch];
};
